import type { Task } from '@/common/api/models/task';
import type { EvalDimRating } from '@/common/api/models/evalDimRating';

function uniqueOrdered(keys: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  keys.forEach((key) => {
    if (!seen.has(key)) {
      seen.add(key);
      result.push(key);
    }
  });
  return result;
}

/**
 * Derives EVALUATION panel dimension keys from the server scored set (option-2 union):
 * scoredDimensionIds ∪ (stored dim grades ∩ resolved config keys).
 */
export function computeApplicableDims(
  task: Task,
  dimGrades: Record<string, EvalDimRating | undefined> | undefined | null,
  resolvedConfigKeys: string[],
): string[] {
  const resolvedKeySet = new Set(resolvedConfigKeys);
  const scoredIds = task.scoredDimensionIds ?? [];
  const storedKeys = Object.keys(dimGrades ?? {});
  const storedInConfig = storedKeys.filter((key) => resolvedKeySet.has(key));

  return uniqueOrdered([...scoredIds, ...storedInConfig]);
}
